  export const ADD_REMINDER = 'ADD_REMINDER';
  export const DELETE_REMINDER = 'DELETE_REMINDER';
  export const CLEAR_REMINDERS = 'CLEAR_REMINDERS';



// WEBPACK FOOTER //
// ./src/constants.js